//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminTransactionController_findAll,
  Response$AdminTransactionController_findAll$Status$200,
  ResponseContentType$AdminTransactionController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminTransactionController_findAll = (options: {
  params: Params$AdminTransactionController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminTransactionController_findAll$Status$200[ResponseContentType$AdminTransactionController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminTransactionController_findAll,
    Response$AdminTransactionController_findAll$Status$200[ResponseContentType$AdminTransactionController_findAll]
  >({
    method: 'AdminTransactionController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
